// Module
var code = "<div> <div class=nlgAnalysisTreePropertyText style=vertical-align:top> <div class=nlgAnalysisTreePropertyName translate> {{:: property.messageKey }} </div> <div class=nlgAnalysisTreePropertyValue ng-attr-name={{::property.messageKey}} ng-attr-data-value=\"{{:: propertyValue }}\"> <span>{{::propertyValue}}</span> </div> </div> </div> ";
// Exports
module.exports = code;